import { PickSessionSchema } from "@redotech/redo-fulfillment-wms-common/schema/pick-session";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const pickAndAssignItemToTote = {
  name: "pickAndAssignItemToTote" as const,
  input: z.object({
    pickSessionId: zExt.objectId(),
    itemId: zExt.objectId(),
    toteId: zExt.objectId(),
    quantity: z.number().int().min(1).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    updatedPickSession: PickSessionSchema.nullish(),
    message: z.string().optional(),
    // Set when the pick was refused because the product requires a
    // picker-entered lot and none is active — client shows the lot prompt.
    needsLot: z.boolean().optional(),
  }),
};
